import React, {useEffect, useRef, useState} from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CarrouselContainer, Card, StyledText, StyledImage } from "./styles";

const SimpleSlider = (props) => {
  const { data } = props;
  let sliderRef = useRef(null);
  const [items, setItems] = useState([]);

  const fixSpecialProductIndex = (products) => {
    const index = products.findIndex((product) => product?.Name?.toLowerCase()?.includes("apartamento"));
    if (index !== -1) {
      const [apartmentProduct] = products.splice(index, 1);
      const middleIndex = Math.floor(products?.length / 2);
      products.splice(middleIndex, 0, apartmentProduct);
    }
   return products;
  }

  useEffect(() => {
    setItems(fixSpecialProductIndex(data));
    const handleResize = () => {
      let specialProductIndex = items?.findIndex((product) => product?.Name?.toLowerCase()?.includes("apartamento"));
      if (specialProductIndex !== -1) {
        let centerIndex = Math.max(0, specialProductIndex - Math.floor(specialProductIndex / 2));
        if (window.innerWidth < 768)
          sliderRef?.slickGoTo(centerIndex + specialProductIndex);
        else
          sliderRef?.slickGoTo(centerIndex);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [data, items]);

 
  const CustomPrevArrow = (props) => {
    const { style, onClick } = props;

    return (
      <FaChevronLeft
        size={42}
        onClick={onClick}
        style={{
          ...style,
          position: "absolute",
          top: "50%",
          left: "-50px",
          transform: "translateY(-50%)",
          cursor: "pointer",
          zIndex: 2,
          color: "#FFF",
        }}
      />
    );
  };

  const CustomNextArrow = (props) => {
    const { style, onClick } = props;
    return (
      <FaChevronRight
        size={42}
        onClick={onClick}
        style={{
          ...style,
          position: "absolute",
          top: "50%",
          left: "calc(100% + 10px)",
          transform: "translateY(-50%)",
          cursor: "pointer",
          zIndex: 2,
          color: "#FFF",
          // display: window.innerWidth < 768 ? 'none' : 'block'
        }}
      />
    );
  };

  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 100,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    cssEase: "ease-in-out",
    touchThreshold: 99999,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: false,
        }
      }
    ]
  };

  return (
    <CarrouselContainer>
      <div className="carrouselContainer">
        <div />
        <Slider
          ref={slider => {
            sliderRef = slider;
          }}
          {...settings}>
          {items.map((product, index) => (
            <div key={index + 1}>
              <Card>
                <StyledText>{product?.Name || ""}</StyledText>
                <StyledImage src={product?.ImageUrl__c} alt={product.name} />
              </Card>
            </div>
          ))}
        </Slider>
        <div />
      </div>
    </CarrouselContainer>
  );
};

export default SimpleSlider;
